import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { HttpPaginationDataProxy } from "@jeanologia/ng-interfaces";
import { EMPTY, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";

import { ProductsDataSource } from "./apps.datasource";
import { CompaniesDataSource } from "./companies.datasource";
import { UsersDataSource } from "./users.datasource";

@Injectable()
export class LicenseDataProxy extends HttpPaginationDataProxy {
	constructor(
		injector: Injector,
		protected httpClient: HttpClient,
		private usersDataSource: UsersDataSource,
		private companiesDataSource: CompaniesDataSource,
		private productsDatSource: ProductsDataSource,
	) {
		super(injector);
	}

	public init(config: any) {
		if (typeof config.service === "string") {
			this.service = this.injector.get(config.service);
		} else {
			this.service = config.service;
		}
		const obs = this.service.init(config.url) as Observable<any>;

		return this.transform$(obs);
	}

	public transform(x: any) {
		if (x) {
			this.totalData.next(x.total);
			x.data.forEach((element: any) => {
				const filtered = element.assignedUsers.filter((el: any) => el.userId !== undefined);
				if (filtered.length > 0) {
					element.usernames$ = this.usersDataSource.getUserNames(filtered);
				} else {
					element.usernames$ = EMPTY;
				}
			});
			return x.data;
		}
		return x;
	}

	public transform$(obs: Observable<any>): Observable<any> {
		return obs.pipe(
			map((data) => this.transform(data)),
			tap((data) => this.refreshCaches(data)),
		);
	}

	private refreshCaches(data: any) {
		if (!data) {
			return;
		}
		this.refreshCompanies(data);
		this.refreshApps(data);
	}

	private refreshCompanies(data: any) {
		const companies = data.filter((el: any) => el.platform).map((el: any) => el.platform.companyId);
		this.companiesDataSource.setBulk(companies);
	}

	private refreshApps(data: any) {
		const apps = data.filter((el: any) => el.platform).map((el: any) => el.platform.appId);
		this.productsDatSource.setBulk(apps);
	}
}
